/**
 * Shared transport secret for merchant login password ciphertext.
 * Must stay in sync with packages/server/src/util/merchantLoginCrypto.ts
 */
const MERCHANT_LOGIN_TRANSPORT_SECRET = "dvaplus-merchant-login-aes-v1";

function bytesToHex(bytes: Uint8Array): string {
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

async function deriveKey(): Promise<CryptoKey> {
  const enc = new TextEncoder();
  const digest = await crypto.subtle.digest("SHA-256", enc.encode(MERCHANT_LOGIN_TRANSPORT_SECRET));
  return crypto.subtle.importKey("raw", digest, { name: "AES-CBC" }, false, ["encrypt"]);
}

/** Encrypt plain password → `ivHex:ciphertextHex` for login API. */
export async function encryptLoginPassword(plain: string): Promise<string> {
  const key = await deriveKey();
  const iv = crypto.getRandomValues(new Uint8Array(16));
  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-CBC", iv },
    key,
    new TextEncoder().encode(plain)
  );
  return `${bytesToHex(iv)}:${bytesToHex(new Uint8Array(encrypted))}`;
}
